import './gb-content-zone.tag.html';
import './gb-rich-content-zone.tag.html';
import './gb-record-zone.tag.html';
import { Template } from './gb-template';
riot.tag2('gb-template', '<div if="{isActive}"> <yield> <div each="{zone in zones}" class="gb-zone-{zone.name}"> <gb-content-zone if="{zone.type === \'Content\'}"></gb-content-zone> <gb-rich-content-zone if="{zone.type === \'Rich_Content\'}"></gb-rich-content-zone> <gb-record-zone if="{zone.type === \'Record\'}"></gb-record-zone> </div> </yield> </div>', '', '', function(opts) {
    this._mixin(Template);
});



/** WEBPACK FOOTER **
 ** ./src/tags/template/gb-template.tag.html
 **/